import styled from 'styled-components';
import type { BrandReportFragment } from '../../../../generated/types';
import { PerceptionBenchmarkSection } from './PerceptionBenchmarkSection';
import { PerceptionSection } from './PerceptionSection';
import { SummarySection } from './SummarySection';
import { VisibilityBenchmarkSection } from './VisibilityBenchmarkSection';
import { VisibilitySection } from './VisibilitySection';

const SectionsContainer = styled.div`
  display: flex;
  gap: 6rem;
  flex-direction: column;
  max-width: 72rem;
  margin: auto;
  width: 100%;
`;

export const Sections = ({ sections }: { sections: BrandReportFragment['sections2'] }) => (
  <SectionsContainer>
    {sections.map(section => {
      switch (section.__typename) {
        case 'ReportSummarySection':
          return <SummarySection key={section.id} section={section} />;
        case 'ReportVisibilitySection':
          return <VisibilitySection key={section.id} section={section} />;
        case 'ReportVisibilityBenchmarkSection':
          return <VisibilityBenchmarkSection key={section.id} section={section} />;
        case 'ReportPerceptionSection':
          return <PerceptionSection key={section.id} section={section} />;
        case 'ReportPerceptionBenchmarkSection':
          return <PerceptionBenchmarkSection key={section.id} section={section} />;
        default:
          return null;
      }
    })}
  </SectionsContainer>
);
